export default __webpack_public_path__ + "f2991aa1e11fa7d676bc9ab9c2aacf54.png";